/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.QuizMeRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './QuizMeRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.QuizMeRpc#asyncBulkGenerateQuizMe
 */
export const ASYNC_BULK_GENERATE_QUIZ_ME_MUTATION_FIELD_NAME = 'com_hubspot_academy_gen_ai_skills_rpc_QuizMeRpc_asyncBulkGenerateQuizMe';
export const ASYNC_BULK_GENERATE_QUIZ_ME_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ASYNC_BULK_GENERATE_QUIZ_ME_MUTATION_FIELD_NAME,
  args: ['videos'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.asyncBulkGenerateQuizMeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.QuizMeRpc#asyncBulkGetQuizMe
 */
export const ASYNC_BULK_GET_QUIZ_ME_QUERY_FIELD_NAME = 'com_hubspot_academy_gen_ai_skills_rpc_QuizMeRpc_asyncBulkGetQuizMe';
export const ASYNC_BULK_GET_QUIZ_ME_QUERY = /* #__PURE__ */registerQuery({
  fieldName: ASYNC_BULK_GET_QUIZ_ME_QUERY_FIELD_NAME,
  args: ['taskIds'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.asyncBulkGetQuizMeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});